'use client';

import type { ComponentProps, CSSProperties } from 'react';
import { Toaster as SonnerToaster } from 'sonner';

const toasterStyle = {
  fontFamily: 'inherit',
  '--border-radius': 'var(--radius)',
  '--normal-bg': 'var(--popover)',
  '--normal-border': 'var(--border)',
  '--normal-text': 'var(--popover-foreground)',
  '--success-bg': 'color-mix(in oklch, var(--primary) 12%, var(--popover))',
  '--success-border': 'color-mix(in oklch, var(--primary) 32%, var(--border))',
  '--success-text': 'var(--primary)',
  '--error-bg': 'color-mix(in oklch, var(--destructive) 12%, var(--popover))',
  '--error-border': 'color-mix(in oklch, var(--destructive) 32%, var(--border))',
  '--error-text': 'var(--destructive)',
} as CSSProperties;

function Toaster({ richColors = true, style, ...props }: ComponentProps<typeof SonnerToaster>) {
  return <SonnerToaster richColors={richColors} style={{ ...toasterStyle, ...style }} {...props} />;
}

export { Toaster };
